/**
 * assets/ingredient-retinol.js
 * Handles:
 *   1. Ingredient retinol tab switching (Original / MAX panels)
 *   2. Slick slider initialisation for custom-featured-products & custom-about-retinol sections
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
   * 1. Tab switcher – ingredient-retinol section
   * ------------------------------------------------------------------ */
  function initIngredientTabs() {
    const tabContainers = document.querySelectorAll('[data-section-type="ingredient-retinol"]');

    tabContainers.forEach(function (section) {
      const tabs   = section.querySelectorAll('[data-js="ir-tab"]');
      const panels = section.querySelectorAll('.ir-section__panel');

      if (!tabs.length || !panels.length) return;

      function activateTab(selectedTab) {
        tabs.forEach(function (tab) {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.classList.toggle('ir-section__tab--active', isSelected);
        });

        const targetId = selectedTab.getAttribute('data-target');
        panels.forEach(function (panel) {
          const isActive = panel.id === targetId;
          panel.classList.toggle('ir-section__panel--active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab) {
        /* Click */
        tab.addEventListener('click', function () {
          activateTab(tab);
        });

        /* Keyboard: arrow keys for roving tabindex */
        tab.addEventListener('keydown', function (event) {
          const currentIndex = Array.from(tabs).indexOf(tab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activateTab(tabs[nextIndex]);
          tabs[nextIndex].focus();
        });
      });
    });
  }

  /* ------------------------------------------------------------------
   * 2. Slick slider – custom-featured-products
   * ------------------------------------------------------------------ */
  function initFeaturedProductsSlider() {
    const sliders = document.querySelectorAll('[data-js="cfp-slider"]');
    if (!sliders.length || typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

    sliders.forEach(function (el) {
      const $el = jQuery(el);
      if ($el.hasClass('slick-initialized')) return;

      $el.slick({
        slidesToShow:   parseFloat(el.getAttribute('data-desktop-slides')) || 3,
        slidesToScroll: 1,
        dots:           true,
        arrows:         true,
        infinite:       false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: parseFloat(el.getAttribute('data-tablet-slides')) || 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseFloat(el.getAttribute('data-mobile-slides')) || 1
            }
          }
        ]
      });
    });
  }

  /* ------------------------------------------------------------------
   * 3. Slick slider – custom-about-retinol
   * ------------------------------------------------------------------ */
  function initAboutRetinolSlider() {
    const sliders = document.querySelectorAll('[data-js="car-slider"]');
    if (!sliders.length || typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

    sliders.forEach(function (el) {
      const $el = jQuery(el);
      if ($el.hasClass('slick-initialized')) return;

      $el.slick({
        slidesToShow:   parseFloat(el.getAttribute('data-desktop-slides')) || 4,
        slidesToScroll: 1,
        dots:           true,
        arrows:         true,
        infinite:       false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: parseFloat(el.getAttribute('data-tablet-slides')) || 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseFloat(el.getAttribute('data-mobile-slides')) || 1
            }
          }
        ]
      });
    });
  }

  /* ------------------------------------------------------------------
   * 4. Ajax Add to Cart – ingredient-retinol cards
   * ------------------------------------------------------------------ */
  function initRetinolATC() {
    document.querySelectorAll('.ir-card__atc-btn[data-ajax-add-to-cart]:not(.js-atc-initialized)').forEach(function (btn) {
      btn.classList.add('js-atc-initialized');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: ['cart-drawer'] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            var currentCount = parseInt((document.querySelector('[data-cart-count]') || {}).getAttribute('data-cart-count') || '0', 10);
            var addedQty = data.items
              ? data.items.reduce(function (s, i) { return s + i.quantity; }, 0)
              : (data.quantity || 1);
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.setAttribute('data-cart-count', currentCount + addedQty);
            });
            var viewport = document.querySelector('.layout--viewport');
            if (viewport) viewport.setAttribute('data-cart-empty', 'false');
            if (typeof window.on === 'function') {
              window.on('theme:cart:updated', function () {
                requestAnimationFrame(function () {
                  if (typeof window.trigger === 'function') {
                    window.trigger('theme:transition:reset:cart-drawer');
                    window.trigger('theme:drawer:open', { side: 'right', view: 'cart-drawer', trigger: btn });
                  }
                });
              }, { once: true });
            }
            if (data.sections) {
              Object.entries(data.sections).forEach(function (entry) {
                var key = entry[0];
                var html = entry[1];
                if (typeof window.trigger === 'function') {
                  window.trigger('theme:cart:' + key.replace(/^cart-/, '') + ':updateHtml', {
                    section: html,
                    load_transitions: true
                  });
                }
              });
            }
          })
          .catch(function (err) {
            // Silent error
          })
          .finally(function () {
            btn.setAttribute('aria-busy', 'false');
          });
      });
    });
  }

  /* ------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------ */
  function init() {
    initIngredientTabs();
    initFeaturedProductsSlider();
    initAboutRetinolSlider();
    initRetinolATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(function(){
   init();
    },1500)
 
  }
})();
